import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'igloo',
      d: 'M-1,-4h1.5v0.5h-1.5zM-2,-3.5h3v0.5h-3zM-2.5,-3h3.5v0.5h-3.5zM-3.5,-2.5h5v1h-5zM-4,-1.5h3.5v1.5h-3.5zM1,-1.5h0.5v0.5h-0.5zM-4,0h3v0.5h-3zM-3,0.5h2v0.5h-2zM-1.5,1h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M0,-4.5h0.5v0.5h-0.5zM0.5,-4h1.5v0.5h-1.5zM1,-3.5h1.5v0.5h-1.5zM1,-3h2v0.5h-2zM1.5,-2.5h1.5v0.5h-1.5zM1.5,-2h2v2.5h-2zM1.5,0.5h1.5v0.5h-1.5zM-0.5,1h2v0.5h-2z',
    },
    { paint: 'frozenWater', d: 'M0,-1h1v0.5h-1zM-0.5,-0.5h2v1.5h-2z' },
    {
      paint: 'snowCap',
      d: 'M-1.5,-4.5h1.5v0.5h-1.5zM-2.5,-4h1.5v0.5h-1.5zM-3,-3.5h1v0.5h-1zM-3.5,-3h1v0.5h-1zM-0.5,-1.5h1.5v0.5h-1.5zM-0.5,-1h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5zM-1,0h0.5v1h-0.5z',
    },
  ],
  pixels: 142,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'igloo',
      d: 'M-1,-4h1.5v0.5h-1.5zM-2,-3.5h3v0.5h-3zM-2.5,-3h3.5v0.5h-3.5zM-3.5,-2.5h5v1h-5zM-4,-1.5h5.5v0.5h-5.5zM-4,-1h5v0.5h-5zM-4,-0.5h4.5v1h-4.5zM-3,0.5h2.5v0.5h-2.5zM-1.5,1h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M0,-4.5h0.5v0.5h-0.5zM0.5,-4h1.5v0.5h-1.5zM1,-3.5h1.5v0.5h-1.5zM1,-3h2v0.5h-2zM1.5,-2.5h1.5v0.5h-1.5zM1.5,-2h2v1h-2zM3,-1h1v1h-1zM2.5,0h0.5v1.5h-0.5zM4,0h0.5v1h-0.5zM-0.5,0.5h1v0.5h-1zM-0.5,1h2v0.5h-2z',
    },
    { paint: 'frozenWater', d: 'M3,0h1v1.5h-1z' },
    {
      paint: 'snowCap',
      d: 'M-1.5,-4.5h1.5v0.5h-1.5zM-2.5,-4h1.5v0.5h-1.5zM-3,-3.5h1v0.5h-1zM-3.5,-3h1v0.5h-1zM1,-1h2v0.5h-2zM0.5,-0.5h2.5v0.5h-2.5zM0.5,0h2v1h-2zM1.5,1h1v0.5h-1z',
    },
  ],
  pixels: 154,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M-1.5,-1.5h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM-4,-1h1v0.5h-1zM1.5,-1h1.5v0.5h-1.5zM4,-1h0.5v0.5h-0.5zM-4,-0.5h8.5v0.5h-8.5zM-3.5,0h6.5v0.5h-6.5zM4,0h0.5v0.5h-0.5zM-3,0.5h7.5v0.5h-7.5zM-0.5,1h1v0.5h-1zM3,1h1v0.5h-1z',
    },
    {
      paint: 'igloo',
      d: 'M1,-3h0.5v0.5h-0.5zM-1.5,-2.5h3v0.5h-3zM-3.5,-2h0.5v0.5h-0.5zM-2.5,-2h0.5v0.5h-0.5zM0.5,-2h1.5v0.5h-1.5zM-4,-1.5h2.5v0.5h-2.5zM0.5,-1.5h2v0.5h-2zM-3,-1h4.5v0.5h-4.5z',
    },
    { paint: 'frozenWater', d: 'M-2,-2h2.5v0.5h-2.5zM-1,-1.5h1v0.5h-1z' },
    {
      paint: 'snowCap',
      d: 'M-2,-3.5h3v1h-3zM-3.5,-2.5h2v0.5h-2zM-3,-2h0.5v0.5h-0.5zM3,-1.5h0.5v0.5h-0.5zM3,-1h1v0.5h-1zM3,0h1v0.5h-1z',
    },
  ],
  pixels: 117,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
